// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","455":"f67f1e62","977":"865031d6"}[chunkId] + ".chunk.js";
};